module.exports = __webpack_public_path__ + "static/img/u300.3c54577.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u300.png
// module id = Ri5t
// module chunks = 1